<template>
    <div class="result-slider">
        <div class="configured-product">
            <VueSlickCarousel v-bind="sliderSettings" ref="resultCarousel" @beforeChange="onBeforeChange">
                <product-image v-for="(image, idx) in images"
                    :className="(idx === currentSlide) ? 'selected' : ''"
                    :image="image">
                </product-image>
            </VueSlickCarousel>
        </div>

        <button type="button" class="icon-restart restart-button" @click="previousScreen()">
            <span class="sr-only">Move back</span>
        </button>

        <div class="configurator-slider-indicator">
            <span class="configurator-current-slide" :style="'left: ' + indicatorLeft + 'px; width: ' + indicatorWidth + 'px'"></span>
        </div>

        <slider-controls
            :showLeftArrow="showLeftArrow"
            :showRightArrow="showRightArrow"
            :showArrowBackground="true"
            @clickArrowLeft="onClickArrowLeft()"
            @clickArrowRight="onClickArrowRight()">
        </slider-controls>
    </div>
</template>

<script src="./result-slider.js"></script>
